function goLoginPage() {
  const path = encodeURIComponent(window.location.hash.slice(1))
  const target = encodeURIComponent(`${window.location.origin}/auth/callback`)
  window.location.replace(
    `https://account.xiaomi.com/oauth2/authorize?skip_confirm=false&response_type=code&client_id=2882303761518839576&redirect_uri=${target}&state=${path}`
  )
}

export default goLoginPage
